import React from 'react'
import classNames from 'classnames'

import styles from './styles/notificator.scss'
import errorIllustration from '../assets/images/wopi-clipped-puzzle.png'
import successIllustration from '../assets/images/wopi-clipped-snap.png'

export default class Notificator extends React.Component {
  render() {
    const { type, children } = this.props

    return (
      <div className={classNames(styles.notificator, styles[type]) + ' notificator'}>
        <section>{children}</section>

        {type === 'error' && <img src={errorIllustration} />}
        {type === 'info' && <img src={successIllustration} />}
        {type === 'success' && <img src={successIllustration} />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Notificator.js